import React from 'react'
import Table from './ReactTable'
import tableHeaders from './TableHeaders'
import { Modal } from 'bootstrap'

function DataTable(props) {
  // Function to programmatically open modal
  const openStudentModal = () => {
    const modalEl = document.getElementById('studentModal')
    const modal = new Modal(modalEl)
    modal.show()
  }

  return (
    <>
      <Table
        style={{ textAlign: 'center' }}
        className='sticky-thc'
        columns={tableHeaders}
        data={props.newTableData}
        studentProfile={props.studentProfile}
      />
    </>
  )
}

export default DataTable
